export const audienceListSchema = [
  {
    field: "key",
    headerName: "key",
    editable: false,
    sortable: false,
    hide: true,
  },
  {
    field: "name",
    headerName: "Name",
    editable: false,
    sortable: true,
    hide: false,
    flex: 240,
  },
  {
    field: "date_created",
    headerName: "Created",
    editable: false,
    sortable: true,
    hide: false,
    flex: 120,
  },
  {
    field: "status",
    headerName: "Status",
    editable: false,
    sortable: true,
    hide: false,
    flex: 80,
  },
];
